import global from './Globals';

export default {
  tableBodyBg: 'rgba(0, 0, 0, 1)',
  tableHeaderBg: global.qfb1,
  tableHeaderText: global.white,
};
